module.exports = __webpack_public_path__ + "media/icons/garbage-7b65a30b.svg";